import { render, staticRenderFns } from "./advocates.vue?vue&type=template&id=071b68ee&"
import script from "./advocates.vue?vue&type=script&lang=ts&"
export * from "./advocates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports